import { render } from "./FilesList.vue?vue&type=template&id=2c3058dd&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"

import "./FilesList.vue?vue&type=style&index=0&id=2c3058dd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3058dd"]])

export default __exports__